module.exports = __webpack_public_path__ + "static/media/ep4.087c3667.jpg";